import { Component, inject } from '@angular/core';
import { ProductListBackendConfigService } from '../../services/product-list-backend-config.service';

@Component({
  selector: 'lib-product-list-backend-wrapper',
  templateUrl: './product-list-backend-wrapper.component.html',
  styleUrl: './product-list-backend-wrapper.component.scss',
  standalone: false
})
export class ProductListBackendWrapperComponent {
  public productListBackendConfigService = inject(ProductListBackendConfigService);
}
